<template>
  <ScreenAdapter>
    <div id="main">
      <Header />
      <Nav />
      <div class="platform-cover" :style="`background:url(${cover}) no-repeat center/cover`"></div>
      <div class="eol-main-container">
        <div class="secure-content direction" ref="139">
          <div class="content-header">
            <div class="text">锚定职教方向&nbsp;&nbsp;&nbsp;赋能时代发展</div>
          </div>
          <div class="content-box">
            <div class="cover-item" v-for="item,index in anchorData" :key="index" :style="`background:url(${item.photo}) no-repeat center/cover`" @click="jumpDetail(item)"></div>
            <div class="flex-hide"></div>
          </div>
        </div>

        <div class="expand-content" ref="137">
          <div class="content-header">
            <div class="text">大力弘扬“三个精神”增添强大思想动力</div>
          </div>
          <div class="content-box">
            <div class="expand-bg">
              <div class="expand-content">
                <div class="swiper-content" v-if="expandData && expandData.length > 0">
                  <swiper :options="expandSwiperOption">
                    <swiper-slide :style="`background-image: url('${item.photo}');`" v-for="item in expandData.slice(0,-3)" :key="item.id" :data-kcid="item.id" :data-kcName="item.name">
                    </swiper-slide>
                  </swiper>
                  <div class="swiper-pagination expand"></div>
                  <div class="swiper-button-next expand" v-text="'>'"></div>
                  <div class="swiper-button-prev expand" v-text="'<'"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content-box expand">
          <div class="cover-item" v-for="item,index in expandData.slice(-3)" :key="index" :style="`background:url(${item.photo}) no-repeat center/cover`" @click="jumpDetail(item)"></div>
        </div>

        <div class="secure-content secure" ref="139">
          <div class="content-header">
            <div class="text">弘扬职业精神 · 恪守职业道德</div>
          </div>
          <div class="content-box">
            <div class="cover-item" v-for="item,index in secureData" :key="index" :style="`background:url(${item.photo}) no-repeat center/cover`" @click="jumpDetail(item)"></div>
            <div class="flex-hide"></div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </ScreenAdapter>

</template>

<script>
import Header from "@/components/Hzvtc/Header.vue"
import Nav from "@/components/Hzvtc/Nav.vue"
import Footer from "@/components/Hzvtc/Footer.vue"
import services from '../../../config/services'
import utils from '../../../config/utils'
import ScreenAdapter from "@/components/ScreenAdapter.vue"


export default {
  data () {
    let that = this
    return {
      cover: require("../../../assets/hzvtc/cover/profession.jpg"),
      school_code: services.HZ_CODE,
      expandSwiperOption: {
        effect: "coverflow",
        loop: true,
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        autoplay: {
          delay: 8000,
          disableOnInteraction: false
        },
        coverflowEffect: {
          rotate: 70,
          stretch: 233,
          depth: 480,
          modifier: 1,
          slideShadows: false,
        },
        preventClicksPropagation: false,
        navigation: {
          // 前进后退按钮 ,不同版本配置方式不同
          nextEl: `.swiper-button-next.expand`,
          prevEl: `.swiper-button-prev.expand`,
        },
        pagination: {
          el: `.swiper-pagination.expand`,
        },
        on: {
          click: function (v) {
            let id = v.target.getAttribute("data-kcid");
            if (id) {
              window.open(`/center/${that.school_code}/hzvtc/detail?id=${id}&key=profession`, "_blank")
            }

          },
        },
      },
      expandData: [], // 弘扬劳动三精神
      secureData: [], // 筑牢职业操守
      anchorData: [], //  锚定职教方向
    }
  },
  components: {
    Header,
    Nav,
    Footer,
    ScreenAdapter
  },
  mounted () {
    this.getListData()
  },
  methods: {
    async getListData () {
      // 弘扬劳动三精神
      await services.getCourseList({ page: 1, size: 100, category_id: "137", school_code: this.school_code }).then(res => {
        this.expandData = res.data.items
      })

      //  锚定职教方向
      await services.getCourseList({ page: 1, size: 2, category_id:  utils.hz_mdzjfxId, school_code: this.school_code }).then(res => {
        this.anchorData = res.data.items
      })

      // 筑牢职业操守
      await services.getCourseList({ page: 1, size: 3, category_id: "139", school_code: this.school_code }).then(res => {
        this.secureData = res.data.items
      })
      await this.jumpPosition()
    },
    jumpDetail (item) {
      window.open(`/center/${this.school_code}/hzvtc/detail?id=${item.id}&key=profession`, "_blank")
    },
    // 锚点定位
    jumpPosition () {
      let that = this
      let position = that.$route.query.id
      if (position) {
        that.$nextTick(() => {
          let topVal = this.$refs[position].getBoundingClientRect().top
          let element = document.getElementsByClassName("outContainer")[0]
          element.scrollTop = topVal - 100
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
#main {
  background: #fff;
}
.platform-cover {
  width: 100%;
  height: 510px;
}

.eol-main-container {
  width: 1400px;
  margin: 0 auto;
  padding: 64px 0 40px;
  position: relative;
  &::before {
    content: '';
    display: inline-block;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 823px;
    width: 1920px;
    height: 898px;
    background: url('../../../assets/hzvtc/list/profession-bg-c.png') no-repeat
      center/cover;
  }
  .content-header {
     width: 1400px;
    margin: 0 auto 30px;
    font-weight: bold;
    font-size: 42px;
    color: #B61E2A;
    background: linear-gradient(0deg, #B61E2A 0%, #EF350A 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-align: center;
    position: relative;
    z-index: 2;
    &::after {
      width: 1400px;
      margin-top: 16px;
      height: 35px;
      content: "";
      display: block;
      background-image: url("../../../assets/hzvtc/list/hzdx-title.png");
      background-size: cover;
      background-position: center;
      // position: absolute;
    }
  }
  .content-box {
    position: relative;
    z-index: 1;
  }
  .expand-content {
    .content-header {
      margin: 60px auto 0;
    }
    .content-box {
      .swiper-slide {
        width: 863px !important;
        height: 485px !important;
        .cover {
          width: 100%;
          height: 100%;
        }
      }

      ::v-deep .swiper-pagination {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        bottom: -32px;
        left: 50%;
        transform: translateX(-50%);
      }
      ::v-deep .swiper-pagination-bullet {
        width: 7px;
        height: 7px;
        background: #b61e2a;
        border: 1px solid #ffffff;
        opacity: 0.5;
        border-radius: 50%;
        display: block;
        transition: all 0.3s;
        margin-right: 4px;
      }

      ::v-deep .swiper-pagination-bullet.swiper-pagination-bullet-active {
        width: 13px;
        height: 7px;
        background: #b61e2a;
        border: 1px solid #ffffff;
        border-radius: 3px;
        opacity: 1;
        margin-right: 7px;
      }
    }
  }
}
.secure-content {
  position: relative;
  &::before {
    content: '';
    display: inline-block;
    width: 1920px;
    height: 368px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: -40px;
    background: url('../../../assets/hzvtc/list/profession-bg-f.png') no-repeat
      0 / cover;
  }
  &.direction {
    .cover-item {
      width: 670px;
      height: 377px;
    }
  }
  &.direction::before { 
    height: 628px;
    
  }
}
.expand-bg {
  background-position: center;
  background-size: cover;
  padding: 48px 0 38px;
  .expand-content {
    width: 1400px;
    margin: 0 auto;
    .swiper-content {
      position: relative;
      width: 100%;
      height: 542px;
      display: flex;
      align-items: center;
      .swiper-container {
        height: 100%;
        .swiper-wrapper {
          .swiper-slide {
            width: 863px;
            height: 485px;
            background: #fff;
            background-size: 100% auto;
            background-position: center;
            cursor: pointer;
            &.swiper-slide-active {
              -webkit-transform: translate3d(0px, 0px, 0px) rotateX(0deg)
                rotateY(0deg) !important;
              -moz-transform: translate3d(0px, 0px, 0px) rotateX(0deg)
                rotateY(0deg) !important;
              -o-transform: translate3d(0px, 0px, 0px) rotateX(0deg)
                rotateY(0deg) !important;
              -ms-transform: translate3d(0px, 0px, 0px) rotateX(0deg)
                rotateY(0deg) !important;
              transform: translate3d(0px, 0px, 0px) rotateX(0deg) rotateY(0deg) !important;
              border: 2px solid red;
            }
          }
        }
      }
      /deep/ .swiper-pagination {
        bottom: 10px;
        width: 100%;
        .swiper-pagination-bullet {
          width: 10px;
          height: 10px;
          background: #cdb29f;
          border-radius: 50%;
          margin: 0 6px;
        }
        .swiper-pagination-bullet.swiper-pagination-bullet-active {
          width: 10px;
          height: 10px;
          background: #dd3639;
          border-radius: 50%;
        }
      }
      .swiper-button-next,
      .swiper-button-prev {
        flex-shrink: 0;
        background-size: cover;
        background: #000;
        z-index: 100;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
        text-align: center;
        line-height: 44px;
        width: 42px;
        height: 44px;
        color: #ffffff;
        font-size: 22px;
        font-family: fangsong;
        font-weight: bold;
      }
      .swiper-button-prev {
        left: 200px;

        background: rgba(0, 0, 0, 0.37);
        border-radius: 22px 0px 0px 22px;
      }
      .swiper-button-next {
        right: 200px;

        background: rgba(0, 0, 0, 0.37);
        border-radius: 0px 22px 22px 0px;
      }
    }
  }
}
.content-box {
  &.expand {
    padding-bottom: 26px;
  }

  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  .cover-item {
    cursor: pointer;
    width: 446px;
    height: 251px;
    margin-bottom: 20px;
  }
  .flex-hide {
    flex: 0 0 446px;
    visibility: hidden;
    display: block;
  }
}
.secure {
  .content-header {
    margin: 46px 0 50px;
  }
}
</style>